export class EntityFieldNotFoundError extends Error {    
    constructor(...params) {
        // @ts-ignore
        super(...params)

        this.name = "EntityFieldNotFoundError"
    }
}